import { createElementBlock as o, openBlock as e, createElementVNode as r } from "vue";
import l from "./index289.js";
const n = {}, a = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function c(s, t, m, p, i, f) {
  return e(), o("svg", a, t[0] || (t[0] = [
    r("path", {
      fill: "currentColor",
      d: "m14.575 3.594.106.172 7.66 13.404c1.146 2.008-.24 4.495-2.51 4.615l-.171.004H4.342c-2.313 0-3.784-2.438-2.762-4.467l.082-.152L9.32 3.766c1.15-2.015 4.006-2.073 5.254-.172Zm-3.871.789-.08.127-7.66 13.405a1.587 1.587 0 0 0 1.244 2.369l.134.005H19.66a1.588 1.588 0 0 0 1.44-2.256l-.062-.119-7.66-13.404a1.586 1.586 0 0 0-2.674-.127ZM12 15.374l.117.007a1 1 0 1 1-.226 0l.109-.007Zm0-6.745a.75.75 0 0 1 .744.648l.007.102v3.74a.75.75 0 0 1-1.493.102l-.007-.102V9.38a.75.75 0 0 1 .75-.75Z"
    }, null, -1)
  ]));
}
const u = /* @__PURE__ */ l(n, [["render", c]]);
export {
  u as default
};
